import React, { useEffect, useRef, useState } from 'react';
import BearerMenu from './menu/BearerMenu';
import BearerMap from './map/BearerMap';
import VersionAgreement from './remoteconfig/VersionAgreement';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, Tab, Tabs, Tooltip } from '@mui/material';
import LeftSidePanel from './order/LeftSidePanel';
import { useAppState, } from '../states/app-state';
import { observer } from 'mobx-react-lite';
import CheckServerRunningStates from './remoteconfig/CheckServerRunningStates';
import CheckDevicesPopup from './login/CheckDevicesPopup';
import ErrorsPopup from './errors/ErrorsPopup';
import Notifier from './Notifier';
import IpAlertMessage from './ipAlertMessage'; // added by Bearer Web Developer
import styles from './Scaffold.module.scss'; // added by Bearer Web Developer
// useStyles removed by Bearer Web Developer
import Split from '@uiw/react-split'; // added by Bearer Web Developer
import { MenuDrawerContext, toggleMenuDrawer } from '../states/contexts/menuDrawer'; // added by Bearer Web Developer
import AddToHomeScreen from './addToHomeScreen'; // added by Bearer Web Developer
import FreeOrderPopup from './freeOrderPopup'; // added by Bearer Web Developer
import RequestPermissionPopup from './requestPermissionPopup';  // added by Bearer Web Developer
import AccessingFeatureMenu from './accessingFeatureMenu'; // added by Bearer Web Developer
import { AccessingFeatureMenuContext } from '../states/contexts/accessingFeatureMenu'; // added by Bearer Web Developer
import Loading from './loading'; // added by Bearer Web Developer
import InviteCode from './inviteCode'; // added by Bearer Web Developer
import CancelledByRiderAfterOriginPopup from './cancelledByRiderAfterOrigin'; // added by Bearer Web Developer



const Scaffold: React.FC = observer(() => {

    const appState = useAppState();
    const sidebar = useRef(null);
    // added by Bearer Web Developer start
    // move and change login state to loginState of mobx states by Bearer Web Developer
    const handleLoginPopup = () => {
        appState.login.setOpen(true); // modified by Bearer Web Developer (login state is moved to loginState of mobx states)
    }
    // added by Bearer Web Developer end
    // useEffect(() => {

    // }, [appState.serverChecked])
    // added by Bearer Web Developer start (FreeOrder)
    const handleCloseFreeOrder = () => {
        appState?.freeOrder?.setOpen(false);
    }
    // added by Bearer Web Developer end (FreeOrder)
    // added by Bearer Web Developer start (RequestPermission)
    const handleCloseRequestPermission = () => {
        appState?.requestPermission?.setOpen(false);
    }
    // added by Bearer Web Developer end (RequestPermission)
    // added by Bearer Web Developer start
    useEffect(() => {
        if (appState.serverChecked) {
            appState.selectedOrder?.setDefaultOrigin();
        }
    }, [appState.serverChecked, appState.selectedOrder])
    // added by Bearer Web Developer end
    // added by Bearer Web Developer start
    const [tooltip, setTooltip] = useState<boolean>(false);
    const [swipe, setSwipe] = useState<boolean>(false);
    const swipable = () => { setSwipe(!swipe); }
    const [openDrawer, setOpenDrawer] = React.useState(false);
    const [accessingFeatureMenuElement, setAccessingFeatureMenuElement] = React.useState<null | HTMLElement>(null);
    const valueMenuDrawer = { openDrawer, setOpenDrawer, swipe };
    const valueAccessingFeatureMenuElement = { accessingFeatureMenuElement, setAccessingFeatureMenuElement };
    useEffect(() => {
        if (appState.serverChecked) {
            if (appState.login.loggedin) {
                const { is_full_discount, fullDiscountUsedOnce } = appState?.fullDiscountAutomatically;
                appState?.freeOrder?.setOpen(is_full_discount && !fullDiscountUsedOnce);
            }
        }
    }, [appState.serverChecked]);
    useEffect(() => {
        if (appState.serverChecked) {
            setTooltip(true);
            setTimeout(() => { setTooltip(false) }, 3000);
        }
    }, [appState.serverChecked, appState.login.loggedin]);
    // added by Bearer Web Developer end
    // added by Bearer Web Developer start (Because of removing the OrderTabs component for individual)
    const login = appState.login.loggedin;
    React.useEffect(() => {
        if (!login && appState.orders.length === 0) {
            (async () => {
                await appState.addOrder();
                appState.selectOrder(appState.orders.length - 1);
            })();
        }
    }, [appState, login])
    // added by Bearer Web Developer end (Because of removing the OrderTabs component for individual)
    // modified by Bearer Web Developer start
    return <>
        <div className={styles.mainContainer}>
            <AddToHomeScreen /> {/* AddToHomeScreen component added by Bearer Web Developer*/}
            {appState?.cancelledByRiderAfterOrigin?.open && <CancelledByRiderAfterOriginPopup />} {/* added by Bearer Web Developer */}
            {appState?.snackMessage && !appState?.cancelledByRiderAfterOrigin?.open && <Notifier />} {/* appState?.snackMessage and !appState?.cancelledByRiderAfterOrigin?.open conditions added by Bearer Web Developer*/}
            {!appState.serverSync &&
                // circular_progress commented by Bearer Web Developer start
                // <div className={styles.circular_progress}>
                //     <CircularProgress className={styles.loader} />
                // </div>
                // circular_progress commented by Bearer Web Developer end
                <Loading /> // added by Bearer Web Developer 
            }
            {appState.serverSync &&
                <div>
                    {appState.serverChecked &&
                        <>
                            {/* FreeOrderPopup component in the following added by Bearer Web Developer*/}
                            {appState?.freeOrder?.open && <FreeOrderPopup open={appState?.freeOrder?.open} handleClose={handleCloseFreeOrder} />}
                            {/* RequestPermissionPopup component in the following added by Bearer Web RequestPermissionPopup*/}
                            {appState?.requestPermission?.open && <RequestPermissionPopup open={appState?.requestPermission?.open} handleClose={handleCloseRequestPermission} />}
                            {/* VerificationMenuContext wrapped by Bearer Web Developer start*/}
                            <AccessingFeatureMenuContext.Provider value={valueAccessingFeatureMenuElement}>
                                <div>
                                    {/* AccessingFeatureMenu component in the following added by Bearer Web Developer*/}
                                    {!appState?.login?.loggedin && <AccessingFeatureMenu accessingFeatureMenuElement={accessingFeatureMenuElement} setAccessingFeatureMenuElement={setAccessingFeatureMenuElement} />}
                                    {/* MenuDrawerContext,Split wrapped by Bearer Web Developer start*/}
                                    <MenuDrawerContext.Provider value={valueMenuDrawer}>
                                        <Split className={styles.container}
                                            renderBar={({ onMouseDown, ...props }) => {
                                                return (
                                                    <div {...props}>
                                                        <div className={styles.adjustable} onMouseDown={onMouseDown}>
                                                        </div>
                                                    </div>
                                                );
                                            }}
                                        >
                                            <div className={styles.orderForm_container}>
                                                <div className={styles.orderForm} ref={sidebar} >
                                                    <div className={styles.bearer_header}>
                                                        <div className={styles.login_menu}>
                                                            {/*modified by Bearer Web Developer, CompleteProfileButton added and later removed for individual  start */}
                                                            {
                                                                appState.login.loggedin ?
                                                                    <div className={styles.hamburger_menu}>
                                                                        <span onClick={toggleMenuDrawer(true, setOpenDrawer)}>
                                                                            <img src="/hamburger_menu.svg" alt="" width={27} height={27} />
                                                                        </span>
                                                                    </div>
                                                                    :
                                                                    <Button onClick={handleLoginPopup} className={styles.login_mobile}  >
                                                                        <img src="/login-mobile.svg" width={28} height={28} alt="" />
                                                                    </Button>
                                                            }
                                                            {/*modified by Bearer Web Developer: CompleteProfileButton added and later removed for individual  end */}
                                                        </div>
                                                        <div className={styles.bearer_logo}>
                                                            <img src="/bearer-individual-logo.png" alt="bearer" height={47} />
                                                        </div>
                                                        {/* added by Bearer Web Developer start*/}
                                                        {
                                                            <div className={styles.whatsapp}>
                                                                <a target='_blank' href={appState?.webAppRemoteConfigParameters?.whatsappLiveSupportNumber}>
                                                                    <Tooltip title={"Whatsapp Live Chat"} arrow={true} open={tooltip}
                                                                        classes={{ tooltip: styles.tooltip, arrow: styles.arrow }}
                                                                    >
                                                                        <img className={styles.whatsapp_image} src="/whatsapp.svg" alt="" width={48} height={48} />
                                                                    </Tooltip>
                                                                </a>
                                                            </div>
                                                        }
                                                        {/* added by Bearer Web Developer end*/}
                                                    </div>
                                                    {/* <OrderTabs />  */} {/* removed for individual by Bearer Web Developer end*/}
                                                    <LeftSidePanel />
                                                    {/**  Put temp stuff here, it will be show below the scrolled div */}
                                                </div>
                                            </div>
                                            <div style={{ minWidth: 80, flex: 1 }}>
                                                <div className={styles.map_container}>
                                                    <BearerMenu />
                                                    <div className={`${styles.map} ${!swipe ? styles.map_mobile : ''} ${!appState.login.loggedin ? styles.map_mobile_logout : ""}`}>
                                                        <div className={`${styles.swipable} ${swipe ? styles.swipable_open : ''}`} onClick={swipable}>
                                                            {
                                                                swipe ?
                                                                    <div className={styles.close}>
                                                                        <img src="/close-dark-grey.svg" alt="" width={20} height={20} />
                                                                        <p>Close</p>
                                                                    </div>
                                                                    :
                                                                    <div className={styles.tap}>
                                                                        <img src="/tap.svg" alt="" />
                                                                        {/* <p>Swipe up to view the map</p> */}
                                                                        <p>Tap to view the map</p>
                                                                    </div>
                                                            }
                                                        </div>
                                                        {/* added by Bearer Web Developer start*/}
                                                        {
                                                            appState?.login?.loggedin && appState?.inviteCode?.value && appState?.inviteCode?.open &&
                                                            <div className={styles.invite_code_desktop}><InviteCode /></div>
                                                        }
                                                        {/* added by Bearer Web Developer end*/}
                                                        <div className={`${styles.bearer_map} ${!swipe ? styles.bearer_map_mobile : ''}`}>
                                                            <BearerMap />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Split>
                                    </MenuDrawerContext.Provider>
                                    {/* MenuDrawerContext,Split wrapped by Bearer Web Developer start*/}
                                </div>
                            </AccessingFeatureMenuContext.Provider>
                            {/* VerificationMenuContext wrapped by Bearer Web Developer end*/}
                            {/* the following IpAlertMessage added by Bearer Web Developer */}
                            {appState.profile.ipAlertMessage && <IpAlertMessage />}
                            <VersionAgreement />
                            <SimpleMessagesDialog />
                            <ErrorsPopup />
                        </>
                    }
                    {!appState.serverChecked && <CheckServerRunningStates />}
                    <CheckDevicesPopup />
                </div>
            }
        </div>
    </>
    // modified by Bearer Web Developer end
});
export default Scaffold;


// OrderTabs Component removed for individual by Bearer Web Developer

const SimpleMessagesDialog: React.FC = observer(() => {
    const appState = useAppState();
    const simpleMessages = appState.simpleMessages;
    const open = simpleMessages.length > 0;
    const simpleMessage = open ? simpleMessages[0] : undefined;
    const handleRemoveMessage = () => {
        appState.removeLastMessage();
    }
    return (
        <>
            <Dialog open={open}
                slotProps={{
                    paper: {
                        sx: { borderRadius: "10px", padding: "44px" },
                    },
                }}
            >
                <div className={styles.simple_messages_dialog}>
                    {simpleMessage && <p>{simpleMessage.message}</p>}
                    <div className={styles.buttons}>
                        <Button onClick={handleRemoveMessage} className={styles.button}>
                            <span>OK</span>
                        </Button>
                    </div>
                </div>
            </Dialog>
        </>
    )
})



